import { loadStripe, type Stripe } from "@stripe/stripe-js";

export type OrganizationCurrency = "USD" | "CAD";

const stripePromiseCache = new Map<string, Promise<Stripe | null>>();

export function normalizeOrganizationCurrency(
  currency?: string | null,
): OrganizationCurrency {
  return currency?.toUpperCase() === "CAD" ? "CAD" : "USD";
}

export function getStripePublishableKey(
  currency?: string | null,
): string {
  const normalized = normalizeOrganizationCurrency(currency);
  const key =
    normalized === "CAD"
      ? import.meta.env.VITE_STRIPE_KEY_CAD
      : import.meta.env.VITE_STRIPE_KEY_USD;

  if (!key) {
    throw new Error(`Missing Stripe publishable key for ${normalized}`);
  }

  return key;
}

export function getStripePromise(currency?: string | null) {
  const publishableKey = getStripePublishableKey(currency);

  if (!stripePromiseCache.has(publishableKey)) {
    stripePromiseCache.set(publishableKey, loadStripe(publishableKey));
  }

  return stripePromiseCache.get(publishableKey)!;
}
